import { ActionReducerMap, createFeatureSelector, createReducer, createSelector } from '@ngrx/store'

import {
  createFormControlState,
  FormState,
  formStateReducer,
  onNgrxForms,
  onNgrxFormsAction,
  SetValueAction,
} from 'ngrx-forms'

export interface AppState {
  uuid: string
  uuidNotFoundControls: FormState<string>
}

export const RootReducers: ActionReducerMap<AppState> = {
  uuid: createReducer(
    '',
    // on(CustomerInfoActions.customerInfoLoad, (): PendingState => PendingState.pending),
    // on(CustomerInfoActions.customerInfoFail, (): PendingState => PendingState.failed),
    // on(CustomerInfoActions.customerInfoSuccess, (): PendingState => PendingState.success),
  ),
  uuidNotFoundControls: createReducer(
    createFormControlState<string>('uuid-not-found', ''),
    onNgrxForms(),
    onNgrxFormsAction(SetValueAction, (state, action) => formStateReducer<string>(state, action)),
  ),
  // loginState: formsReducer,
}

export const selectRootAppState = createFeatureSelector<AppState>('app')

export const selectAppState = {
  uuidNotFoundControls: createSelector(
    selectRootAppState,
    (state: AppState): FormState<string> => state.uuidNotFoundControls,
  ),
} as const
